import { useEffect } from "react";
import SpotUnavailableLight from "@utilitywarehouse/hearth-svg-assets/lib/spot-unavailable-light.svg";
import {
  BodyText,
  Card,
  CardContent,
  Flex,
  Heading,
  useMediaQuery,
  media,
} from "@utilitywarehouse/hearth-react";

import Sentry from "../sentry";
import { getToken, isExpired } from "../context/auth/Token";
import { useAuthContext } from "../context/auth/useAuthContext";

export const UnauthenticatedDataTest = {
  UNAUTHENTICATED_CUSTOMER_ERROR: "UNAUTHENTICATED_CUSTOMER_ERROR",
};

const Unauthenticated: React.FC = () => {
  const { instigator } = useAuthContext();

  const customerAccountID = instigator?.accountID;

  useEffect(() => {
    const { expiry, token } = getToken();

    let reason = "Unauthenticated user.";
    if (!token?.length) {
      reason = "Token is empty.";
    } else if (isExpired(expiry)) {
      reason = "Token has expired.";
    }

    Sentry.getCurrentScope()
      .setLevel("warning")
      .setTag("accountID", customerAccountID)
      .setTag("accountNumber", instigator.accountNumber)
      .setTransactionName("Unauthenticated")
      .captureMessage(`User does not have a valid token. ${reason}`);
  }, []);

  const isMobile = useMediaQuery(media.below("tablet"));
  const isTabletOrDesktop = useMediaQuery(media.not("mobile"));

  return (
    <Card
      spacing="md"
      marginTop="350"
      data-testid={UnauthenticatedDataTest.UNAUTHENTICATED_CUSTOMER_ERROR}
      width="fit-content"
    >
      <CardContent
        spacing="lg"
        direction={isTabletOrDesktop ? "row" : "column"}
        alignItems={isMobile ? "center" : "start"}
      >
        <img
          src={SpotUnavailableLight}
          style={{
            width: "160px",
            height: "174px",
          }}
        />

        <Flex direction="column" spacing="lg" padding="400">
          <Heading size="lg">Sorry, your link has expired</Heading>
          <BodyText size="md">
            Unfortunately time has run out and you can no longer use this link.
            <br /> To get a new link contact our customer service team 0333 777
            0777.
          </BodyText>
        </Flex>
      </CardContent>
    </Card>
  );
};

export default Unauthenticated;
